import {Component, Input} from "@angular/core";

@Component({
    selector: "fui-summary",
    styleUrls: ["./summary.component.scss"],
    templateUrl: "./summary.component.html"
})
export class FUISummaryComponent {
    @Input() label: string;

    constructor() {

    }
}
